<!-- Refund Modal -->
<p-dialog [visible]="showRefundModal()" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '850px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="sticky left-0 top-0 z-1 surface-0 py-3 px-4 flex align-items-center justify-content-between border-bottom-1 border-300">
      <h2 class="mb-0 text-sm" [innerHTML]="'SALES_RETURN.SALES_RETURN_FOR' | translate : { name: invoiceData().billing_name, id: invoiceData().client_id }"></h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)"></div>
    </div>
    <!-- Header -->
    <form [formGroup]="clientSalesReturnForm">
      <!-- Content -->
      <div class="px-3 pt-2 surface-50">
        <!-- Heading -->
        <div class="text-right mb-2">
          <h2 class="text-xl mb-0">{{'SALES_RETURN.SALES_RETURN' | translate}}</h2>
          <p class="mb-0 text-xs" [innerHTML]="'SALES_RETURN.FOR_INVOICE' | translate : { number_prefix: invoiceData().number_prefix }"></p>
        </div>
        <!-- Heading -->

        <!-- Table -->
        <p-table [value]="(salesReturnServices$ | async)!" styleClass="p-0 border-top-1 border-bottom-1 border-300 m-0" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th class="surface-100 border-none w-22rem"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.PRODUCT_NAME' | translate}}</span></th>
              <th class="surface-100 border-none"><span class="text-xs text-600 white-space-nowrap"></span></th>
              <th class="surface-100 border-none"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.INVOICE_AMOUNT' | translate}}</span></th>
              <th class="bg-blue-100 border-none border-left-1"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.QTY' | translate}}</span></th>
              <th class="bg-blue-100 border-none"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.SALES_RETURN' | translate}}</span></th>
              <th class="bg-blue-100 border-none"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.DESCRIPTION' | translate}}</span></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-service>
            <tr class="text-sm">
              <td class="py-2 white-space-nowrap" [ngClass]="service.is_total_column ? 'surface-100' : 'surface-50' ">
                @if (!service.is_total_column) {
                  <div>{{service.name_primary_language}}</div>
                } @else {
                }
              </td>
              <td class="py-2 white-space-nowrap" [ngClass]="service.is_total_column ? 'surface-100' : 'surface-50' ">
                @if (service.is_total_column) {
                  <div><strong>{{service.name_primary_language}}</strong></div>
                }
              </td>
              <td class="py-2 white-space-nowrap" [ngClass]="service.is_total_column ? 'surface-100' : 'surface-50' ">
                @if (!service.is_total_column!) {
                  <div>{{service.invoice_amount | currencyformat}}</div>
                } @else {
                  <strong>{{ getInvoiceTotalAmount | currencyformat }}</strong>
                }
              </td>
              <td class="py-2 white-space-nowrap border-left-1 border-300" [ngClass]="service.has_total_cell ? 'bg-blue-100' : 'bg-blue-50' ">
                @if (service.has_tax_cell) {
                  <div class="text-center"></div>
                }
                @if (service.has_total_cell) {
                  <div class="text-center font-bold"></div>
                }
                @if ((!service.has_tax_cell) && (!service.has_total_cell)) {
                  <div class="flex align-items-center">
                    <div class="flex-1">
                      <app-input-number [formGroup]="clientSalesReturnForm" [controlName]="getSalesReturnFormControl('service_quantity_'+service.invoice_line_id)"
                        [styleClass]="'w-3rem text-sm'" [conditionToFormat]="false" (onBlur)="getSalesCalculation()" />
                    </div>
                    @if (service.type !== 'Service') {
                      <span style="font-weight: bold; padding: 5px;">  of {{service.quantity}} </span>
                    }
                  </div>
                }
                @if (getSalesReturnFormControl('service_quantity_'+service.invoice_line_id)  && getSalesReturnFormControl('service_quantity_'+service.invoice_line_id).hasError('max')) {
                  <div class="text-xs p-error mt-1">
                    {{'SALES_RETURN.MSG.MAXIMIM_QUANTITY_REQUIRED' | translate : { quantity :service.quantity } }}
                  </div>
                }
              </td>
              <td class="py-2 white-space-nowrap" [ngClass]="service.has_total_cell ? 'bg-blue-100' : 'bg-blue-50' ">
                @if (service.has_tax_cell) {
                  <div class="text-center">$5<sup>.00</sup></div>
                }
                @if (service.has_total_cell) {
                  <div class="text-center font-bold">{{ getSalesReturnAmountTotal | currencyformat}}</div>
                }
                @if ((!service.has_tax_cell) && (!service.has_total_cell)) {
                  <div class="flex align-items-center w-7rem">
                    <span class="p-inputgroup-addon"> {{ currencySymbol$ | async }}</span>
                    <!-- <p-inputNumber mode="decimal" [maxFractionDigits]="4" [format]="false" inputStyleClass="w-5rem h-2rem" [formControlName]="'service_sales_return_amount_'+service.invoice_line_id" (onBlur)="getSalesCalculation()"> </p-inputNumber> -->
                    <div class="flex-1">
                      <app-input-number [formGroup]="clientSalesReturnForm" [controlName]="getSalesReturnFormControl('service_sales_return_amount_'+service.invoice_line_id)"
                        [styleClass]="'w-5rem text-sm'" [conditionToFormat]="false" (onBlur)="getSalesCalculation()" />
                    </div>
                  </div>
                }
                @if (getSalesReturnFormControl('service_description_'+service.invoice_line_id) && getSalesReturnFormControl('service_sales_return_amount_'+service.invoice_line_id).hasError('max')) {
                  <div
                    class="text-xs p-error mt-1">
                    {{'SALES_RETURN.MSG.MAXIMIM_REQUIRED' | translate : { amount :service.invoice_amount | currencyformat } }}
                  </div>
                }
              </td>
              <td class="py-2 white-space-nowrap" [ngClass]="service.has_total_cell ? 'bg-blue-100' : 'bg-blue-50' ">
                @if (service.has_tax_cell) {
                  <div class="text-center"></div>
                }
                @if (service.has_total_cell) {
                  <div class="text-center font-bold"></div>
                }
                @if ((!service.has_tax_cell) && (!service.has_total_cell) && service.type.toLowerCase() !== 'product') {
                  <div>
                    <input type="text" class="w-full text-sm" pInputText placeholder="" [formControlName]="'service_description_'+service.invoice_line_id" />
                  </div>
                }
                @if ((!service.has_tax_cell) && (!service.has_total_cell) && service.type.toLowerCase() === 'product') {
                  <div>
                    <p-select [options]="skuReturnReasons" [appendTo]="'body'" [formControlName]="'service_sku_return_reason_'+service.invoice_line_id" optionLabel="reason_primary_name" styleClass="text-sm w-full" filterBy="reason_primary_name" [placeholder]="'SALES_RETURN.REASON_PLACEHOLDER' | translate">
                      <ng-template pTemplate="selectedItem">
                        @if (getSalesReturnFormControl('service_sku_return_reason_'+service.invoice_line_id).value) {
                          <div class="flex align-items-center">
                            <div class="text-sm">{{getSalesReturnFormControl('service_sku_return_reason_'+service.invoice_line_id).value.reason_primary_name}}</div>
                          </div>
                        }
                      </ng-template>
                    </p-select>
                  </div>
                }
                @if (getSalesReturnFormControl('service_description_'+service.invoice_line_id)  && getSalesReturnFormControl('service_description_'+service.invoice_line_id).dirty &&  getSalesReturnFormControl('service_description_'+service.invoice_line_id).invalid) {
                  <div class="text-xs p-error mt-1">
                    {{'common.errors.validations.REQUIRED' | translate : {fieldlabel: "SALES_RETURN.LBL_DESC" | translate } }}
                  </div>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- Table -->
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="py-3 px-4">
        <!-- Grid -->
        <div class="grid">
          <!-- Form Group -->
          <div class="col-12 md:col-6">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.REASON_FOR_RETURN' | translate}}</label>
            <p-select [options]="returnReasons" formControlName="reason" optionLabel="value" styleClass="text-sm w-full" filterBy="name" [placeholder]="'SALES_RETURN.REASON_PLACEHOLDER' | translate">
              <ng-template pTemplate="selectedItem">
                @if (SalesReturnReasonFormControl.value) {
                  <div class="flex align-items-center">
                    <div class="text-sm">{{'SALES_RETURN.REASONS.'+SalesReturnReasonFormControl.value.value | translate}}</div>
                  </div>
                }
              </ng-template>
              <ng-template let-returnReason pTemplate="item">
                <div class="text-sm">{{'SALES_RETURN.REASONS.'+returnReason.value | translate}}</div>
              </ng-template>
            </p-select>
            @if (SalesReturnReasonFormControl.dirty && SalesReturnReasonFormControl.invalid) {
              <app-error-msg styleClass="md:block"
                [errors]="SalesReturnReasonFormControl.errors"
                [fieldLabel]="'SALES_RETURN.MSG.REASON_REQUIRED' | translate" />
            }
          </div>
          <!-- Form Group -->
          <!-- Form Group -->
          <div class="col-12 md:col-6">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.SALES_REP' | translate}}</label>
            <staff-selector [formGroup]="clientSalesReturnForm" [controlName]="SalesRepFormControl" [canRepresetative]="isClientRepresentative" [claims]="claims" [styleClass]="'w-full text-sm py-0 align-items-center'" />
            @if (SalesRepFormControl.dirty && SalesRepFormControl.invalid) {
              <app-error-msg styleClass="md:block" [errors]="SalesRepFormControl.errors" [fieldLabel]="'SALES_RETURN.SALES_REP' | translate" />
            }
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="col-12 md:col-12">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.COMMENTS' | translate}}</label>
            <input type="text" class="w-full text-sm" pInputText  formControlName="comment" />
            @if (SalesReturnReasonCommentFormControl.dirty && SalesReturnReasonCommentFormControl.invalid) {
              <app-error-msg styleClass="md:block"
                [errors]="SalesReturnReasonCommentFormControl.errors"
                [fieldLabel]="'SALES_RETURN.LBL_COMMENTS' | translate" />
            }
          </div>
          <!-- Form Group -->
        </div>
        <!-- Grid -->
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="border-top-3 border-300">
        <h4 class="mb-0 text-sm font-normal border-bottom-1 border-300 py-3 px-4" [innerHTML]="'SALES_RETURN.SALES_RETURN_FOR' | translate : { name: invoiceData().billing_name, id: invoiceData().client_id }"></h4>

        <div class="py-3 px-4">
          <!-- Table -->
          <p-table [value]="refundCalculationData" styleClass="p-0 m-0" responsiveLayout="scroll" [loading]="TableLoader$ | async">
            <ng-template pTemplate="header">
              <tr>
                <th class="surface-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.TOTAL_INV_AMT' | translate}}</span></th>
                <th class="surface-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.TOTAL_PAYMENT_REC' | translate}}</span></th>
                <th class="surface-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.TOTAL_SALES_RETURN' | translate}}</span></th>
                <th class="bg-yellow-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.EXCESS_AMT' | translate}}</span></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-productsData>
              <tr class="text-sm">
                <td class="py-2 white-space-nowrap text-center">{{productsData.total_invoice_amt | currencyformat }}</td>
                <td class="py-2 white-space-nowrap">{{productsData.total_payment_received | currencyformat}}</td>
                <td class="py-2 white-space-nowrap">{{ (productsData.total_sales_return  + getSalesReturnAmountTotal) | currencyformat}}</td>
                <td class="py-2 bg-yellow-50 white-space-nowrap"><strong>{{productsData.excess_amt_to_return | currencyformat}}</strong></td>
              </tr>
            </ng-template>
          </p-table>
          <!-- Table -->
        </div>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="sticky left-0 bottom-0 z-1 surface-0 flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <p-button label="Cancel" styleClass="p-button-text text-sm" (click)="closePopup(false)" />
        @if (chooseRefundPaymentMethods.value && salesReturnAmount > 0) {
          <div>
            <p-button [disabled]="!clientSalesReturnForm.valid" [label]="'SALES_RETURN.SALES_RETURN_AMOUNT' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ) }" icon="fa fa-chevron-down" iconPos="right" styleClass="text-sm"
              (click)="clientSalesReturnForm.valid ? refundOptions.toggle($event) : null" />
            <p-popover #refundOptions styleClass="overflow-hidden right-0 text-sm w-18rem -ml-3">
              <ng-template #content>
                <ul class="list-none -m-4 py-2 px-0 text-xs text-900">
                  <li (click)="ProcessSalesReturn('credit')" class="cursor-pointer hover:surface-300 px-3 py-2 font-bold">{{'SALES_RETURN.REFUND_TO_E_WALLET' | translate }}</li>
                  <li (click)="refundBackToSource()" class="cursor-pointer hover:surface-300 px-3 py-2 font-bold">{{'SALES_RETURN.REFUND_BACK_TO_SOURCE' | translate }}</li>
                  <!-- <li (click)="offlineRefund()" class="cursor-pointer hover:surface-300 px-3 py-2 font-bold">Offline Refund <span class="font-normal">(Refund options on next screen)</span></li> -->
                </ul>
              </ng-template>
            </p-popover>
          </div>
        }
        @else {
          <div>
            <p-button [disabled]="!clientSalesReturnForm.valid" [loading]="btnLoading | async" 
             [label]="salesReturnAmount > 0 ? ('SALES_RETURN.SALES_RETURN_AMOUNT' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ) }) : ('SALES_RETURN.SALES_RETURN' | translate)"
               styleClass="text-sm"
              (click)="ProcessSalesReturn('credit')" />
          </div>
        }
        <!-- @if (!chooseRefundPaymentMethods.value) {
          <div>
            <p-button [disabled]="!clientSalesReturnForm.valid || salesReturnAmount === 0" [loading]="btnLoading | async" [label]="salesReturnAmount > 0 ? ('SALES_RETURN.REFUND_TO_E_WALLET_BTN' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ) }) : ('common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate)"   styleClass="text-sm"
              (click)="ProcessSalesReturn('credit')" />
          </div>
        } -->
        <!-- <div class="flex align-items-center">
        <p-button type="button" [label]="salesReturnAmount > 0 ? ('SALES_RETURN.BTN_CREDIT' | translate) : ('common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate)" styleClass="text-sm" (click)="ProcessSalesReturn()" [loading]="btnLoading | async" [disabled]="!clientSalesReturnForm.valid"></p-button>
      </div> -->
    </div>
    <!-- Modal Footer -->
  </form>
</ng-template>
</p-dialog>
<!-- Refund Modal -->

<!-- Refund Confirm Modal -->
<p-dialog [visible]="refundConfirmModal" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '670px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
    <div class="relative text-center p-5 md:px-7">

      <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
      (click)="refundConfirmModal = false"></div>

      <i class="fa-solid fa-triangle-exclamation p-error text-7xl"></i>

      <h4 class="text-base md:text-lg my-3 font-normal"><strong class="font-bold">{{'SALES_RETURN.ARE_YOU_SURE' | translate}}</strong> <br class="hidden md:block">
      @if (PaymentMethodDetails) {
        <div [innerHTML]="'SALES_RETURN.THIS_ACTION_CANNOT_BE_UNDONE' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ), payment_method: PaymentMethodDetails.number }"></div>
      }
    </h4>

    <div class="mt-5">
      <label class="font-medium text-700 text-xs mb-3 block uppercase">{{'SALES_RETURN.PLEASE_TYPE_REFUND_TO_CONFIRM' | translate}}</label>
      <input type="text" class="w-full text-sm" pInputText [formControl]="refundConfirmControl" placeholder="Type REFUND here">
      @if (refundConfirmControl.dirty && refundConfirmControl.invalid) {
        <small class="p-error block mt-2">
          {{'SALES_RETURN.PLEASE_TYPE_REFUND_TO_CONFIRM_ERROR' | translate}}
        </small>
      }
    </div>

  </div>
  <!-- Content -->

  <!-- Modal Footer -->
  <div class="flex align-items-center justify-content-between p-3 border-top-1 border-300">
    <p-button label="Cancel" styleClass="p-button-text text-sm" (click)="refundConfirmModal = false" />
    <p-button [label]="'SALES_RETURN.YES_REFUND' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ) }" styleClass="text-sm" [disabled]="!refundConfirmControl.valid" (click)="ProcessSalesReturn('online')" [loading]="btnLoading.value" />
  </div>
  <!-- Modal Footer -->

</ng-template>

</p-dialog>
<!-- Refund Confirm Modal -->
